import React, { FunctionComponent } from 'react';
import PageHeader from '@/components/layout/PageHeader';
import PageFooter from '@/components/layout/PageFooter';
import PageContent from '@/components/layout/PageContent';
import ContentContainer from '@/components/layout/ContentContainer/ContentContainer';

interface IProps {
  hideFooter?: boolean;
  noContentContainer?: boolean;
  children: React.ReactNode;
}

const BarHeaderLayout: FunctionComponent<IProps> = ({ children, hideFooter = false, noContentContainer = false }) => (
  <>
    <PageHeader primary />
    <PageContent>
      {noContentContainer ? <div>{children}</div> : <ContentContainer>{children}</ContentContainer>}
    </PageContent>
    {!hideFooter && <PageFooter />}
  </>
);

export default BarHeaderLayout;
